"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _preact = require("preact");
var _nonSecure = require("nanoid/non-secure");
var classNames = require("classnames");
var getFileTypeIcon = require("../../utils/getFileTypeIcon.js");
var ignoreEvent = require("../../utils/ignoreEvent.js");
var FilePreview = require("../FilePreview.js");
var FileCard = /*#__PURE__*/function (_preact$Component) {
  _inherits(FileCard, _preact$Component);
  var _super = _createSuper(FileCard);
  function FileCard(props) {
    var _this;
    _classCallCheck(this, FileCard);
    _this = _super.call(this, props);
    _this.form = document.createElement('form');
    _this.updateMeta = function (newVal, name) {
      _this.setState(function (_ref) {
        var formState = _ref.formState;
        return {
          formState: _objectSpread(_objectSpread({}, formState), {}, _defineProperty({}, name, newVal))
        };
      });
    };
    _this.handleSave = function (e) {
      e.preventDefault();
      var fileID = _this.props.fileCardFor;
      _this.props.saveFileCard(_this.state.formState, fileID);
    };
    _this.handleCancel = function () {
      var file = _this.props.files[_this.props.fileCardFor];
      _this.props.uppy.emit('file-editor:cancel', file);
      _this.props.toggleFileCard(false);
    };
    _this.saveOnEnter = function (ev) {
      if (ev.keyCode === 13) {
        ev.stopPropagation();
        ev.preventDefault();
        var file = _this.props.files[_this.props.fileCardFor];
        _this.props.saveFileCard(_this.state.formState, file.id);
      }
    };
    _this.renderMetaFields = function () {
      var metaFields = _this.getMetaFields() || [];
      var fieldCSSClasses = {
        text: 'uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input'
      };
      return metaFields.map(function (field) {
        var id = "uppy-Dashboard-FileCard-input-".concat(field.id);
        var required = _this.props.requiredMetaFields.includes(field.id);
        return (0, _preact.h)("fieldset", {
          key: field.id,
          className: "uppy-Dashboard-FileCard-fieldset"
        }, (0, _preact.h)("label", {
          className: "uppy-Dashboard-FileCard-label",
          htmlFor: id
        }, field.name), field.render !== undefined ? field.render({
          value: _this.state.formState[field.id],
          onChange: function onChange(newVal) {
            return _this.updateMeta(newVal, field.id);
          },
          fieldCSSClasses: fieldCSSClasses,
          required: required,
          form: _this.form.id
        }, _preact.h) : (0, _preact.h)("input", {
          className: fieldCSSClasses.text,
          id: id,
          form: _this.form.id,
          type: field.type || 'text',
          required: required,
          value: _this.state.formState[field.id],
          placeholder: field.placeholder // If `form` attribute is not supported, we need to capture pressing Enter to avoid bubbling in case Uppy is
          // embedded inside a <form>.
          ,

          onKeyUp: 'form' in HTMLInputElement.prototype ? undefined : _this.saveOnEnter,
          onKeyDown: 'form' in HTMLInputElement.prototype ? undefined : _this.saveOnEnter,
          onKeyPress: 'form' in HTMLInputElement.prototype ? undefined : _this.saveOnEnter,
          onInput: function onInput(ev) {
            return _this.updateMeta(ev.target.value, field.id);
          },
          "data-uppy-super-focusable": true
        }));
      });
    };
    var _file = _this.props.files[_this.props.fileCardFor];
    var _metaFields = _this.getMetaFields() || [];
    var storedMetaData = {};
    _metaFields.forEach(function (field) {
      storedMetaData[field.id] = _file.meta[field.id] || '';
    });
    _this.state = {
      formState: storedMetaData
    };
    _this.form.id = (0, _nonSecure.nanoid)();
    return _this;
  } // TODO(aduh95): move this to `UNSAFE_componentWillMount` when updating to Preact X+.
  _createClass(FileCard, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // eslint-disable-line react/no-deprecated
      this.form.addEventListener('submit', this.handleSave);
      document.body.appendChild(this.form);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.form.removeEventListener('submit', this.handleSave);
      document.body.removeChild(this.form);
    }
  }, {
    key: "getMetaFields",
    value: function getMetaFields() {
      return typeof this.props.metaFields === 'function' ? this.props.metaFields(this.props.files[this.props.fileCardFor]) : this.props.metaFields;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var file = this.props.files[this.props.fileCardFor];
      var showEditButton = this.props.canEditFile(file);
      return (0, _preact.h)("div", {
        className: classNames('uppy-Dashboard-FileCard', this.props.className),
        "data-uppy-panelType": "FileCard",
        onDragOver: ignoreEvent,
        onDragLeave: ignoreEvent,
        onDrop: ignoreEvent,
        onPaste: ignoreEvent
      }, (0, _preact.h)("div", {
        className: "uppy-DashboardContent-bar"
      }, (0, _preact.h)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
      }, this.props.i18nArray('editing', {
        file: (0, _preact.h)("span", {
          className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
      })), (0, _preact.h)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        form: this.form.id,
        title: this.props.i18n('finishEditingFile'),
        onClick: this.handleCancel
      }, this.props.i18n('cancel'))), (0, _preact.h)("div", {
        className: "uppy-Dashboard-FileCard-inner"
      }, (0, _preact.h)("div", {
        className: "uppy-Dashboard-FileCard-preview",
        style: {
          backgroundColor: getFileTypeIcon(file.type).color
        }
      }, (0, _preact.h)(FilePreview, {
        file: file
      }), showEditButton && (0, _preact.h)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
        onClick: function onClick(event) {
          // When opening the image editor we want to save any meta fields changes.
          // Otherwise it's confusing for the user to click save in the editor,
          // but the changes here are discarded. This bypasses validation,
          // but we are okay with that.
          _this2.handleSave(event);
          _this2.props.openFileEditor(file);
        },
        form: this.form.id
      }, this.props.i18n('editFile'))), (0, _preact.h)("div", {
        className: "uppy-Dashboard-FileCard-info"
      }, this.renderMetaFields()), (0, _preact.h)("div", {
        className: "uppy-Dashboard-FileCard-actions"
      }, (0, _preact.h)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn" // If `form` attribute is supported, we want a submit button to trigger the form validation.
        // Otherwise, fallback to a classic button with a onClick event handler.
        ,

        type: 'form' in HTMLButtonElement.prototype ? 'submit' : 'button',
        onClick: 'form' in HTMLButtonElement.prototype ? undefined : this.handleSave,
        form: this.form.id
      }, this.props.i18n('saveChanges')), (0, _preact.h)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
        type: "button",
        onClick: this.handleCancel,
        form: this.form.id
      }, this.props.i18n('cancel')))));
    }
  }]);
  return FileCard;
}(_preact.Component);
module.exports = FileCard;